import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from "react-redux";
import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Button,
    Grid,
    Paper,
    Typography,
  } from "@material-ui/core";
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { makeStyles } from "@material-ui/core/styles";
import { ValidatorForm } from "react-material-ui-form-validator";
import { MuiPickersUtilsProvider, KeyboardDatePicker } from "@material-ui/pickers";
import { CboProfesionales } from '../../../cbos/CboProfesionales';
import { CboCentrosMedicos } from '../../../cbos/CboCentrosMedicos';
import { CboEspecialidades } from '../../../cbos/CboEspecialidades';
import DateFnsUtils from "@date-io/date-fns";
import esLocale from "date-fns/locale/es";
import { useForm } from "../../../../hooks/useForm";
import moment from "moment";
import { ListaLicencias } from './ListaLicencias';
import { validarSoloUnPermiso } from '../../../../helpers/permisos';
import { CONFIGURACIONTURNOS_PERMISOS } from '../../../../utils/permisos';
import { TIPO_PARAMETRIZACION_TURNOS } from '../../../../utils/constants';
import { CboTipoLicenciaProfesionales } from '../../../cbos/CboTipoLicenciaProfesionales';
import { agregarLicenciaProfesional, fetchlicenciasProfesionales, licenciasProfesionalesLimpiar, licenciasProfesionalesUpdateDisabled } from '../../../../actions/turnos/licenciasProfesionales';
import { armarParametros } from '../../../../helpers/parametros';
import { fetchConToken } from '../../../../helpers/fetch';
import { AlertFinalizadoStepper } from '../../../stepper/AlertFinalizadoStepper';
import { startAlerta } from '../../../../actions/ui/alertas';
import { fetchMotivosBajaTurno } from '../../../../actions/turnos/motivosBajaTurno';

const useStyles = makeStyles((theme) => ({
    root: {
        padding:10,
        flexGrow: 1,
        marginTop:10,
    },
    input: {
        padding: 10,
    },
    grid: {
        backgroundColor: theme.palette.background.paper,
    },
    formControl: {
        marginTop: 5,
        minWidth: 120,
        marginLeft: 20,
        margin: theme.spacing(1),
    }, 
    button: {
        marginLeft: 25,
    }
}));

const stateInitial = {
    idEfectorLicencias: 0,
    idMotivoBajaTurno: '',
    idTipoLicencia: '',
    fechaDesde: '',
    fechaHasta: ''
  }  

export const HomeLicenciasProfesionales = () => {
    const classes = useStyles();
    const dispatch = useDispatch();
    
    const [idEspecialidad, setIdEspecialidad] = useState(null);
    const [idCentroMedico, setIdCentroMedico] = useState(null);
    const [idProfesional, setIdProfesional] = useState(null);
    const [editRegistro, setEditRegistro] = useState(false);
    const [openQuestion, setOpenQuestion] = useState(false);
    const [turnosTomados, setTurnosTomados] = useState(0);
    const [formValues, handleInputChange, reset, setearValor, , , , , setearVariosValores] = useForm(stateInitial);
    const { idEfectorLicencias, idMotivoBajaTurno, idTipoLicencia, fechaDesde, fechaHasta } = (formValues);
    
    const { items: motivosBajaItems, cargada: motivosBajaCargados } = useSelector((state) => state.motivosBajaTurno);
    const { items, cargada, disabled } = useSelector((state) => state.licenciasProfesionales);
    const { permisos: permisosUser } = useSelector(state => state.auth)

    useEffect(() => {
        dispatch( licenciasProfesionalesLimpiar() );
        dispatch( licenciasProfesionalesUpdateDisabled(true) );
    }, [dispatch]);

    useEffect(() => {
        if (!motivosBajaCargados)
            dispatch( fetchMotivosBajaTurno() );
    }, [dispatch, motivosBajaCargados]);

    const handleInputChangeCascada = ({ target }) => {
        switch (target.name) {
            case 'idCentroMedico':
                setIdCentroMedico(target.value);
                setIdProfesional(null);
                setIdEspecialidad(null);
                break;
            case 'idProfesional':
                if(target.value === ''){
                    setIdProfesional(null);
                }
                else{
                    setIdProfesional(target.value);
                    setIdEspecialidad(null);
                }
                break;
            case 'idEspecialidad':
                setIdEspecialidad(target.value);
                break;
            default:
                break;
        }
        editRegistro&& reset(stateInitial);
        dispatch( licenciasProfesionalesLimpiar() );
    }

    const handleSearch = () => {
        dispatch( licenciasProfesionalesUpdateDisabled(true) );
        idEspecialidad&& dispatch( fetchlicenciasProfesionales(idCentroMedico, idProfesional, idEspecialidad) );
    }

    const handleNuevoRegistro = () => {
        reset(stateInitial);
        setEditRegistro(false);
        dispatch( licenciasProfesionalesUpdateDisabled(false) );
    }

    const handleCloseAlert = () => {
        setOpenQuestion(false);
    };

    const handleVerificarTurnos = () => {
        const verificarTurnosTomados = async () => {
            setTurnosTomados(0);
            handleInputChange({target:{name: 'idMotivoBajaTurno', value: null}})
            try{
                const parametros = armarParametros(idEspecialidad, idCentroMedico, idProfesional, null, null, null, null, null, null, null, null, null, moment(fechaHasta).toISOString(), null, moment(fechaDesde).toISOString());
                const response = await fetchConToken(`Agenda/traerPorProfesionalFecha?${parametros}`);
                const contentType = response.headers.get("content-type");
                if (contentType && contentType.indexOf("application/json") !== -1) {
                    const lista = await response.json();
                    if (response.status !== 200) throw lista.errores;
                    if(lista.length > 0){                       //Valido si tiene turnos tomados para ese rango de fecha
                        setTurnosTomados(lista);
                        setOpenQuestion(true);
                    }else{
                        handleSubmit();
                    }
                }
            } catch (err){
                dispatch(startAlerta(err, "warning", `¡Error!`));
            }
        };

        if(!openQuestion)
            verificarTurnosTomados();
        else
            handleSubmit();
    }

    const handleSubmit = () => {
        const parametros = {
            idEfector: idProfesional,
            IdCm: idCentroMedico,
            idEspecialidad: idEspecialidad,
            idTipoLicencia: idTipoLicencia,
            fechaDesde: fechaDesde,
            fechaHasta: fechaHasta,
            idEfectorLicencias: idEfectorLicencias,
        }

        dispatch( agregarLicenciaProfesional(parametros, idMotivoBajaTurno) );
        setOpenQuestion(false);
    }

    return ( 
        <>
            <ValidatorForm onSubmit={handleVerificarTurnos} instantValidate={true}>
                <div className={classes.root}>
                    <Grid container justify="center" spacing={1}>  
                        <Grid item xs={8} className={classes.grid}>
                            <Grid container direction="row" alignItems="center" spacing={1}>
                                <Grid item xs={12} md={4}>
                                    <Paper className={classes.input}>
                                        <CboCentrosMedicos 
                                            manejadorInputChange={handleInputChangeCascada}
                                            idCombo={'idCentroMedico'}
                                            filtrarPorUsuario={true}
                                            valor={idCentroMedico}
                                        />
                                    </Paper>
                                </Grid>
                                <Grid item xs={12} md={4}>
                                    <Paper className={classes.input}>
                                        <CboProfesionales 
                                            manejadorInputChange={handleInputChangeCascada}
                                            idCentroMedico={idCentroMedico}
                                            cargarEnCascada={true}
                                            porCentroMedico={true}
                                            valor={idProfesional}
                                            required={'required'}
                                        />
                                    </Paper>
                                </Grid>
                                <Grid item xs={12} md={4}>
                                    <Paper className={classes.input}>
                                        <CboEspecialidades
                                            manejadorInputChange={handleInputChangeCascada}
                                            setIdEspecialidad={setIdEspecialidad}
                                            idCentroMedico={idCentroMedico}
                                            idProfesional={idProfesional}
                                            idTipoParametrizacion={TIPO_PARAMETRIZACION_TURNOS.NORMAL}
                                            cargarEnCascada={true}
                                            valor={idEspecialidad}
                                        />
                                    </Paper>
                                </Grid>
                                <Grid item xs={12} md={1}>
                                </Grid>
                                <Grid item xs={12} md={3}>
                                    <Paper className={classes.input}>
                                        <CboTipoLicenciaProfesionales
                                            manejadorInputChange={handleInputChange}
                                            disabledForm={disabled}
                                            valor={idTipoLicencia} 
                                        />
                                    </Paper>
                                </Grid>
                                <Grid item xs={12} md={1}>
                                </Grid>
                                <Grid item xs={12} md={3}>
                                    <Paper>
                                        <MuiPickersUtilsProvider
                                            locale={esLocale}
                                            utils={DateFnsUtils}
                                        >
                                            <KeyboardDatePicker
                                                margin="normal"
                                                id="dialogfechaDesde"
                                                label="Fecha Inicio"
                                                format="dd/MM/yyyy"
                                                okLabel="Aceptar"
                                                required={true}
                                                disabled={disabled}
                                                minDate={new Date()}
                                                clearLabel="Limpiar"
                                                cancelLabel="Cancelar"
                                                minDateMessage={`La fecha no puede ser anterior a la fecha actual`}
                                                value={
                                                    moment(fechaDesde).isValid()
                                                    ? moment(fechaDesde)
                                                    : null
                                                }
                                                onChange={(date) => {
                                                    setearValor("fechaDesde", moment(date));
                                                }}
                                                KeyboardButtonProps={{
                                                    "aria-label": "change date",
                                                }}
                                            />
                                        </MuiPickersUtilsProvider>
                                    </Paper>
                                </Grid>
                                <Grid item xs={12} md={3}>
                                    <Paper>
                                        <MuiPickersUtilsProvider
                                            locale={esLocale}
                                            utils={DateFnsUtils}
                                        >
                                            <KeyboardDatePicker
                                                margin="normal"
                                                id="dialogfechaHasta"
                                                label="Fecha Fin"
                                                format="dd/MM/yyyy"
                                                okLabel="Aceptar"
                                                required={true}
                                                disabled={disabled}
                                                minDate={fechaDesde}
                                                clearLabel="Limpiar"
                                                cancelLabel="Cancelar"
                                                minDateMessage={`La fecha no puede ser anterior a la fecha de inicio`}
                                                value={
                                                    moment(fechaHasta).isValid()
                                                    ? moment(fechaHasta)
                                                    : null
                                                }
                                                onChange={(date) => {
                                                    setearValor("fechaHasta", date);
                                                }}
                                                KeyboardButtonProps={{
                                                    "aria-label": "change date",
                                                }}
                                            />
                                        </MuiPickersUtilsProvider>
                                    </Paper>
                                </Grid>
                                <Grid item xs={12} md={1}>
                                </Grid>
                            </Grid>
                            <Grid container direction="row" justify="center" spacing={1} style={{marginTop: 20, marginBottom: 5}}>
                                <Button 
                                    variant="contained" 
                                    color="primary" 
                                    disabled={idEspecialidad === null}
                                    className={classes.button}
                                    onClick={handleSearch}
                                >
                                    Buscar
                                </Button>
                                <Button 
                                    variant="contained" 
                                    color="primary" 
                                    disabled={disabled}
                                    className={classes.button}
                                    type='submit'
                                >
                                    Grabar
                                </Button>
                                <Button 
                                    variant="contained" 
                                    color="primary" 
                                    className={classes.button}
                                    disabled={!validarSoloUnPermiso(permisosUser, CONFIGURACIONTURNOS_PERMISOS.ALTA)}
                                    onClick={handleNuevoRegistro}
                                >
                                    Nuevo
                                </Button>
                            </Grid>
                        </Grid>
                    </Grid>

                    <Grid container className={classes.root} justify="center" spacing={1}>  
                        <Grid item xs={6} className={classes.grid}>
                            <ListaLicencias 
                                cargada={cargada}
                                permisosUser={permisosUser}
                                setEditRegistro={setEditRegistro}
                                setearVariosValores={setearVariosValores}
                                items={items.filter(s => !s.fecProCBaja)}
                                validarSoloUnPermiso={validarSoloUnPermiso}
                            />
                        </Grid>
                    </Grid>

                    <Grid container className={classes.root} justify="center" spacing={1}>  
                        <Grid item xs={6} className={classes.grid}>
                            <Accordion disabled={!cargada}>
                                <AccordionSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    aria-controls="panel1a-content"
                                    id="panel1a-header"
                                >
                                    <Typography>Licencias Inactivas o Pasadas</Typography>
                                </AccordionSummary>
                                <AccordionDetails style={{display: 'block'}}>
                                    <ListaLicencias 
                                        cargada={cargada}
                                        permisosUser={permisosUser}
                                        setEditRegistro={setEditRegistro}
                                        setearVariosValores={setearVariosValores}
                                        items={items.filter(s => s.fecProCBaja)}
                                        validarSoloUnPermiso={validarSoloUnPermiso}
                                    />
                                </AccordionDetails>
                            </Accordion>
                        </Grid>
                    </Grid>
                    {openQuestion && 
                        <AlertFinalizadoStepper
                            open={openQuestion}
                            pregunta={"Nueva Licencia"}
                            dialogText={`Se van a cancelar ${turnosTomados.length} turnos tomados esta seguro?`}
                            buttonCancel={"Cancelar"}
                            buttonSubmit={"Continuar"}
                            showComboDialog={true}
                            itemsCombo={motivosBajaItems}
                            labelCombo={'Motivo'}
                            idCombo={'idMotivoBajaTurno'}
                            manejadorInputChange={handleInputChange}
                            valor={idMotivoBajaTurno}
                            handleClose={handleCloseAlert}
                            handleSend={() => {}}                   //execute only parent ValidatorForm submit
                        />
                    }
                </div>
            </ValidatorForm>
        </>
     );
}
